import React, { Fragment } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'

import Separator from '../../../components/helpers/Separator'
import ControlBar from './ControlBar'

const PageHeader = () => {
  return (
    <Fragment>
      <Grid justify="space-between" align="center" gutter={0.4}>
        <Col flex={3}>
          <Title size="h3" color="dark3" noWrap>
            Grupos
          </Title>
        </Col>
        <Col flex={1}>
          <ControlBar />
        </Col>
      </Grid>

      <Separator weight={4} />
    </Fragment>
  )
}

export default PageHeader
